import { Grid, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import ThemeBtn from "../../Common/ThemeBtn";
import ThemeContext from "../../context";
import Context from "../context";
import useTransferPositions from "./service/useTransferPositions";

// ----------------------------------------------------------------------

export const TransferRowBtn = () => {
	const { state } = useContext(Context);
	const { theme } = useContext(ThemeContext);

	const { translate } = useLocales();
	const { onTransferPositions, isLoading } = useTransferPositions();

	return (
		<Grid container sx={{ mb: 1 }} justifyContent='space-between' alignItems='center' gap={2}>
			<Grid item>
				<Typography variant='subtitle2' color={theme?.colors.primaryText}>
					{translate(`Has seleccionado ${state.selectedPositions.length} posiciones. `)}
				</Typography>
			</Grid>
			<Grid item>
				<ThemeBtn
					variant='contained'
					color='primary'
					sx={{ minWidth: 120 }}
					loading={isLoading}
					title='Realizar traspaso'
					onClick={onTransferPositions}
				/>
			</Grid>
		</Grid>
	);
};

export default TransferRowBtn;
